module.exports = __webpack_public_path__ + "img/loading.d71d8ccb.gif";